module.exports = __webpack_public_path__ + "7c8b65c1f567df42657d0d0648340b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/mangooid-logo.png
// module id = 59
// module chunks = 0